<template>
    <span class="form-checkbox" :class="{toggle}" v-bind="$attrs">
        <input type="hidden" :name="name" :value="valueOff" v-if="showHidden">
        <label>
            <input type="checkbox" :name="name" v-model="checked" :value="valueOn" v-on="events" v-bind="$attrs" :id="_id" :disabled="!!disabled">
            <i class="material-icons form-checkbox-icon pointer" aria-hidden="true" :title="title" role="img"></i>
            <span v-if="label" v-html="label"/>
            <span v-else class="hidden">Auswahl Option</span>
            <slot></slot>
        </label>
    </span>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator';
    import {AbstractFormInput} from '../../mixins/AbstractFormInput';
    import FormRow from './FormRow.vue';

    @Component({
        name: 'FormInputCheckbox',
        inheritAttrs: false,
        emits: ['update:modelValue'],
    })
    export default class FormInputCheckbox extends AbstractFormInput
    {
        readonly $parent: FormRow;

        @Prop({
            type: [Boolean, Number, String, Array],
        }) modelValue: InputValueTypes;

        @Prop({
            type: [Number, String],
            default: 10,
            required: false,
        }) tabindex: number | string;

        @Prop({
            type: [Number, String, Boolean],
            default: 0,
            required: false,
        }) valueOff: number | string | boolean;

        @Prop({
            type: [Number, String, Boolean],
            default: 1,
            required: false,
        }) valueOn: number | string | boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) showHidden: boolean;

        @Prop({
            type: String,
            default: null,
            required: false,
        }) title: Nullable<string>;

        @Prop({
            type: [Boolean, Number],
            default: false,
            required: false,
        }) disabled: boolean | number;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) toggle: boolean;

        @Prop({
            type: String,
            default: '',
            required: false,
        }) label: string;

        @Prop({
            type: Object,
            default()
            {
                return {};
            },
        }) events: object;

        inputValue: InputValueTypes = null as unknown as InputValueTypes;

        get checked(): number | string | boolean
        {
            return true === this.modelValue || this.modelValue === this.valueOn || (Array.isArray(this.modelValue) && this.modelValue.includes(this.valueOn));
        }

        set checked(newValue: number | string | boolean)
        {
            this.inputValue = newValue ? this.valueOn : this.valueOff;

            if (!Array.isArray(this.modelValue))
            {
                this.$emit('update:modelValue', this.inputValue);
                this.validateValue(this.inputValue); // @todo: check if correct
            }
            else
            {
                let value: Array<InputValueType> = Object.assign([], this.modelValue);

                if (newValue)
                {
                    value.push(this.valueOn);
                }
                else
                {
                    value.splice(value.indexOf(this.valueOn), 1);
                }

                this.$emit('update:modelValue', value);
                this.validateValue(value);
            }
        }

        created()
        {
            this.inputValue = this.checked ? this.valueOn : this.valueOff;
        }
    };
</script>